import React from "react";
import Card from "../../components/Card";

export default function CategoryCard({ category, onEdit, onDelete, onFilter }) {
  return (
    <Card
      title={category.nameBr}
      status={{
        label: category.enabled ? "Ativo" : "Inativo",
        color: category.enabled ? "green-400" : "disabled",
      }}
      onEdit={onEdit}
      onDelete={onDelete}
      onFilter={onFilter}
    >
      <p>{`ID: ${category.id}`}</p>
      <p>{`Ordem: ${category.order}`}</p>
      <p>{`Bebida: ${category.drink.nameBr}`}</p>
    </Card>
  );
}
